/**
 * @packageDocumentation
 * @module HackerAPI.Organization
 */
import { __extends } from "tslib";
import Base from "../base/base";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import Member from "../event/team/member/member";
import Event from "../event/event";
import { parseDate } from "../utils/utils";
/**
 * A data container with an organization with static methods for interfacing with hackerapi
 * @class
 * @extends { HackerAPI.Base }
 */
var Organization = /** @class */ (function (_super) {
    __extends(Organization, _super);
    /**
     * Creates an instance of an organization
     * @constructor
     * @param org
     */
    function Organization(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, members = _b.members, events = _b.events, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * @type { number }
         */
        _this.id = id;
        /**
         * @type { string }
         */
        _this.name = name;
        /**
         * @type { HackerAPI.Organization.Member[] }
         */
        _this.members = (members || []).map(function (m) { return new Member(m); });
        /**
         * @type { HackerAPI.Event[] }
         */
        _this.events = (events || []).map(function (e) { return new Event(e); });
        _this.createdAt = parseDate(created_at || createdAt);
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Fetches an organization
     * @param org
     * @param org.id
     * @param [token]
     * @returns
     */
    Organization.fetch = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/organizations/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Organization(data); });
    };
    /**
     * Creates an organization
     * @param org
     * @param [token]
     * @returns
     */
    Organization.create = function (org, token) {
        return HackerAPIFetch({
            path: "/v2/organizations",
            method: "POST",
            token: token,
            body: org.toHackerAPIFormat()
        }).then(function (data) { return new Organization(data); });
    };
    /**
     * Updates an organization. Note members and events won't be affected.
     * @param org
     * @param [token]
     * @returns
     */
    Organization.update = function (org, token) {
        return HackerAPIFetch({
            path: "/v2/organizations/" + org.id,
            method: "PUT",
            token: token,
            body: org.toHackerAPIFormat()
        }).then(function (data) { return new Organization(data); });
    };
    /**
     * Deletes an organization
     * @param org
     * @param [token]
     * @returns
     */
    Organization.delete = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/organizations/" + id,
            method: "DELETE",
            token: token
        });
    };
    // ------------------------------------------ EVENTS ------------------------------------------
    /**
     * Attaches an event to an organization
     * @param org
     * @param event
     * @param { string | Object} token
     * @returns
     */
    Organization.addEvent = function (_a, _b, token) {
        var id = _a.id;
        var slug = _b.slug;
        return HackerAPIFetch({
            path: "/v2/organizations/" + id + "/events",
            method: "POST",
            token: token,
            body: {
                event_slug: slug
            }
        }).then(function (data) { return new Organization(data); });
    };
    /**
     * Disassociates an event from an organization
     * @param org
     * @param event
     * @param { string | Object} token
     * @returns
     */
    Organization.removeEvent = function (_a, _b, token) {
        var id = _a.id;
        var slug = _b.slug;
        return HackerAPIFetch({
            path: "/v2/organizations/" + id + "/events",
            method: "DELETE",
            token: token,
            body: {
                event_slug: slug
            }
        }).then(function (data) { return new Organization(data); });
    };
    // --------------------------------------------- MEMBERS ---------------------------------------------
    /**
     * Associates a user with an organization
     * @param org
     * @param org.id
     * @param user
     * @param user.id
     * @param [token]
     * @returns
     */
    Organization.addMember = function (_a, _b, token) {
        var orgId = _a.id;
        var userId = _b.id;
        return HackerAPIFetch({
            path: "/v2/organization/" + orgId + "/members",
            method: "POST",
            token: token,
            body: {
                user_id: userId
            }
        }).then(function (data) { return new Organization(data); });
    };
    /**
     * Disassociates a user from an organization
     * @param org
     * @param org.id
     * @param user
     * @param user.id
     * @param [token]
     * @returns
     */
    Organization.removeMember = function (_a, _b, token) {
        var orgId = _a.id;
        var userId = _b.id;
        return HackerAPIFetch({
            path: "/v2/organization/" + orgId + "/members",
            method: "DELETE",
            token: token,
            body: {
                user_id: userId
            }
        });
    };
    return Organization;
}(Base));
export default Organization;
//# sourceMappingURL=organization.js.map